<template>
	<div class="box-lgpd">
		<span>
			Ao navegar em nossa plataforma você está automaticamente de acordo com nossas Políticas de Privacidade e Termos de Uso.
			<a @click="openTermLGPD()"
				><b><u>Saber mais</u></b></a
			>
		</span>
		<div class="box-buttons">
			<ButtonDefault @click.native="acceptCookies()" text="Aceitar" />
			<ButtonDefault secondary-color="true" @click.native="refuseCookies()" text="Recusar" />
		</div>
	</div>
</template>

<script>
import ButtonDefault from "./buttons/ButtonDefault"
import moment from "moment"
export default {
	name: "AlertLGPD",
	components: { ButtonDefault },
	methods: {
		acceptCookies() {
			localStorage.setItem("acceptCookies", moment().format("DD/MM/YYYY HH:MM:SS"))
			this.$emit("accept", true)
		},
		refuseCookies() {
			localStorage.setItem("refuseCookies", moment().format("DD/MM/YYYY HH:MM:SS"))
			this.$emit("accept", true)
		},
		openTermLGPD() {
			let routeData = this.$router.resolve({ name: "TermsLGPD" })
			window.open(routeData.href, "_blank")
		}
	}
}
</script>

<style scoped>
a {
	cursor: pointer;
}
.box-lgpd {
	padding: 10px 11% 10px 11%;
	width: 100vw;
	min-height: 90px;
	background: #fff;
	position: fixed;
	bottom: 0;
	-webkit-box-shadow: 1px 0px 3px 0px rgba(212, 212, 212, 0.4);
	-moz-box-shadow: 1px 0px 3px 0px rgba(212, 212, 212, 0.4);
	box-shadow: 1px 0px 3px 0px rgba(212, 212, 212, 0.9);
	z-index: 999999 !important;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.box-lgpd span {
	font-family: Roboto;
	padding-right: 10px;
}

.box-buttons {
	width: 230px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.box-buttons * {
	padding-right: 10px;
}

@media only screen and (max-width: 768px) {
	.box-buttons {
		flex-direction: column;
	}
	.box-buttons button {
		margin: 5px 0;
	}
}
</style>
